import { Component, inject } from '@angular/core';
import { AvatarComponent } from '@group24ag/flowkit';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-ui-avatar',
  imports: [AvatarComponent],
  template: `
    <div class="flex flex-col gap-4">
      <h1 class="heading-title">Avatar</h1>
      <div class="space-y-4">
        <h2 class="text-sm font-medium">Image</h2>
        <div class="flex items-center gap-x-7">
          <flk-avatar
            [src]="avatarUrl"
            [imagePadding]="6"
            size="sm"
            (clicked)="onClick()" />
          <flk-avatar
            [src]="avatarUrl"
            [clickable]="false"
            [imagePadding]="7"
            size="md"
            (clicked)="onClick()" />
          <flk-avatar
            [src]="avatarUrl"
            [imagePadding]="8"
            size="lg"
            (clicked)="onClick()" />
          <flk-avatar
            [src]="avatarUrl"
            [imagePadding]="9"
            size="xl"
            (clicked)="onClick()" />
          <flk-avatar
            [src]="avatarUrl"
            [imagePadding]="10"
            size="2xl"
            (clicked)="onClick()">
            <div class="flex flex-col justify-center">
              <span class="font-medium">John Doe</span>
              <span class="text-dune-500 text-xs">
                {{ 'j.doe@group24.de' }}
              </span>
            </div>
          </flk-avatar>
        </div>
      </div>

      <div class="space-y-4">
        <h2 class="text-sm font-medium">Initials</h2>
        <div class="flex items-center gap-x-7">
          <flk-avatar initials="JD" size="sm" (clicked)="onClick()" />
          <flk-avatar
            initials="JD"
            size="md"
            [clickable]="false"
            (clicked)="onClick()" />
          <flk-avatar initials="JD" size="lg" (clicked)="onClick()" />
          <flk-avatar initials="JD" size="xl" (clicked)="onClick()" />
          <flk-avatar
            initials="JD"
            size="2xl"
            [mirrorLayout]="true"
            (clicked)="onClick()">
            <div class="mb-1 flex flex-col items-end justify-center">
              <span class="font-medium">John Doe</span>
              <span class="text-dune-500 text-xs">
                {{ 'j.doe@group24.de' }}
              </span>
            </div>
          </flk-avatar>
        </div>
      </div>

      <div class="space-y-4">
        <h2 class="text-sm font-medium">Icon Fallback</h2>
        <div class="flex items-center gap-x-7">
          <flk-avatar size="sm" (clicked)="onClick()" />
          <flk-avatar size="md" [clickable]="false" (clicked)="onClick()" />
          <flk-avatar size="lg" (clicked)="onClick()" />
          <flk-avatar size="xl" (clicked)="onClick()" />
          <flk-avatar size="2xl" (clicked)="onClick()">
            <div class="mb-1 flex flex-col justify-center">
              <span class="font-medium">John Doe</span>
              <span class="text-dune-500 text-xs">
                {{ 'j.doe@group24.de' }}
              </span>
            </div>
          </flk-avatar>
        </div>
      </div>
    </div>
  `,
})
export class UIAvatarComponent {
  /** INJECTIONS **/
  /****/
  private readonly logger = inject(NGXLogger);

  /** PROPERTIES **/
  /** Dummy avatar image for the preview. */
  protected readonly avatarUrl = 'assets/images/gorilla.svg';

  protected onClick() {
    this.logger.debug('Avatar clicked');
  }
}
